import { ApolloClient, from, InMemoryCache } from '@apollo/client/core/index.js'
import type { GaryClientOptions } from './index.ts'
import { authLink, createTracerLink, errorLink, headerLink, httpLink } from './links/index.ts'

const apolloLinks = ({ uri, getToken, getCookie, sessionCookieKey, logger, tracer }: GaryClientOptions) => [
  ...(tracer ? [createTracerLink({ tracer, uri })] : []),
  authLink(getToken, getCookie, sessionCookieKey, logger),
  errorLink(),
  headerLink,
  httpLink({ uri }),
]

export const createGaryClient = ({ uri, getToken, getCookie, sessionCookieKey, logger, tracer }: GaryClientOptions) => {
  const links = apolloLinks({
    uri,
    getToken,
    getCookie,
    sessionCookieKey,
    logger,
    tracer,
  })

  return new ApolloClient({
    clientAwareness: { name: '@mntn-select/gary-client' },
    link: from(links),
    cache: new InMemoryCache(),
  })
}

export type GaryClient = ReturnType<typeof createGaryClient>
